module.exports = __webpack_public_path__ + "static/media/receta-15.5926e3e1.png";